import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const MenuBookIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"menu_book"} ref={ref}/>
});

MenuBookIcon.displayName = "MenuBookIcon";
